import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row, FormGroup, CardHeader, Button, Nav, NavItem, NavLink, TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input, Label } from 'reactstrap';
import classnames from 'classnames';
import formSchema from '../Utils/schema.json';
import { RenderField } from '../Utils/renderFields';
import { RenderErrorMessage } from '../Utils/renderErrorMessages';
import { LabelText } from '../Utils/Input';
import { userOptions } from '../UserManagement/Constant/UserOptions';
import PhoneInput, { formatPhoneNumberIntl } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { handleChangePassword, handleChangeUser } from '../UserManagement/Constant/JsonConstant';
import { tabChange } from "../Utils/SetDefaultRowData";
import CommonButton from '../Utils/CommonButton';
import { CustomerProfile } from './CustomerProfile';
import { CustomerEditProfile } from './CustomerEditProfile';
import { handleSubmitFunction } from '../LightWeightCustomer/Constant/formUtil';
import { MAX_IMG_SIZE } from '../Utils/Constants';
import { ImageUpload } from '../Utils/ImageUpload';
import { handleSubmitCustomerFunction } from '../LightWeightCustomer/Constant/handleSubmitCustomer';

export default function ProviderDetail({
    isChangePasswordModal, setDialCode, customerId, dialCode, setIsEdit, isEdit, setSelectedCountry, profileOptions, fetchCustomerData, profilePermission, values, handleChange, handleBlur, errors, touched, setFieldTouched, setFieldValue, user, userId, navigate, dispatch, setLoading, profile, setChangePasswordStatus, isProfile, stateData, cityData, setSelectedState, handleImageUpload, initialValues, intialFormValues, dirty
}) {
    const [activeTab, setActiveTab] = useState('1');
    const roleName = localStorage.getItem('roleName')
    const toggleEdit = () => {
        setIsEdit(prevState => !prevState);
    };
    const [isValidFile, setIsValidFile] = useState(true)
    const [inputFileName, setInputFileName] = useState("")
    const [selectedFile, setSelectedFile] = useState(null)
    const [imageSrc, setImageSrc] = useState(null)
    const userDetails = [
        { label: "First Name", value: user?.profile?.firstName },
        { label: "Last Name", value: user?.profile?.lastName },
        { label: "Phone Number", value: `${user?.userDetails?.dialCode} ${user?.userDetails?.phone}` },
        { label: "Email Address", value: user?.email },
        { label: "User Name", value: user?.userDetails?.userName || '' },
        { label: "User Role", value: user?.role },
    ];
    const [validateSizeError, setValidateSizeError] = useState(null);
    const [imageOn, setImageOn] = useState(false)

    useEffect(() => {
        return () => {
            if (imageSrc) {
                URL.revokeObjectURL(imageSrc);
            }
        };
    }, [imageSrc]);
    return (
        <div className="live-preview">
            {!isChangePasswordModal ? <>
                <div>
                    {roleName !== "Customer" ? <>{formSchema.map((section, sectionIndex) => (
                        <React.Fragment key={sectionIndex}>
                            {section.title === "User" && section.sections &&
                                section.sections.map((subSection, subSectionIndex) => (
                                    subSection.sectionTitle !== "Password Change" && (
                                        <CardBody key={subSectionIndex}>
                                            <Row className='gy-3'>
                                                {subSection.fields.filter(field => {
                                                    if ((field.name === "username" || field.name === "userrole")) {
                                                        field.disable = true;
                                                    } else {
                                                        field.disable = false;
                                                    }
                                                    if (field.name === "status" && !isEdit) {
                                                        return false;
                                                    }
                                                    return true;
                                                }).map((field, fieldIndex) => (
                                                    <Col
                                                        xxl={field.name === "description" ? 12 : 4}
                                                        md={field.name === "description" ? 12 : 6}
                                                        lg={field.name === "description" ? 12 : 4}
                                                        key={`${subSectionIndex}-${fieldIndex}`}
                                                    >
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={
                                                                "ms-0 rv-form-label"
                                                            }
                                                            className={field.required ? "text-danger" : ""}
                                                            displayText={field.label}
                                                            important={field.required ? "*" : ""}
                                                        />
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] &&
                                                                errors[field.name]
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                                } `}
                                                            displayText={field.placeholder
                                                            }
                                                        />
                                                        {field.type === 'phone' ? (
                                                            <FormGroup>
                                                                <PhoneInput
                                                                    international
                                                                    countryCallingCodeEditable={false}
                                                                    className={`form-control ${touched[field.name] && errors[field.name] ? 'error-input' : ''}`}
                                                                    placeholder={field.placeholder}
                                                                    value={values[field.name]}
                                                                    onChange={(value) => setFieldValue(field.name, value)}
                                                                    onBlur={() => setFieldTouched(field.name, true)}
                                                                    disabled={field?.autoload && field.isEdit}
                                                                />
                                                                {/* {touched[field.name] && errors[field.name] && (
                                                                    <div className="text-danger validation-font-size">
                                                                        {errors[field.name]}
                                                                    </div>
                                                                )} */}
                                                            </FormGroup>
                                                        ) : (
                                                            <>
                                                                <RenderField
                                                                    field={field}
                                                                    handleChange={handleChange}
                                                                    handleBlur={handleBlur}
                                                                    values={values}
                                                                    touched={touched}
                                                                    errors={errors}
                                                                    setFieldTouched={setFieldTouched}
                                                                    setFieldValue={setFieldValue}
                                                                    options={userOptions}
                                                                    removePlaceholder={true}
                                                                />
                                                                {/* <RenderErrorMessage
                                                                    field={field}
                                                                    touched={touched}
                                                                    errors={errors}
                                                                /> */}
                                                            </>
                                                        )}
                                                    </Col>
                                                ))}
                                            </Row>
                                        </CardBody>
                                    )
                                ))}
                        </React.Fragment>
                    ))}
                    </> : <CustomerEditProfile dialCode={dialCode} setDialCode={setDialCode} setSelectedState={setSelectedState} stateData={stateData} cityData={cityData} setSelectedCountry={setSelectedCountry} profileOptions={profileOptions} values={values} setFieldTouched={setFieldTouched} setFieldValue={setFieldValue} touched={touched} errors={errors} handleBlur={handleBlur} handleChange={handleChange} />}

                </div>
                <div className='mt-3'>
                    {/* <h6 className='rv-form-label'>Photo Upload</h6>
                    <div className={`d-flex flex-column justify-content-center align-items-center py-3 border border-3 border-dotted ${isValidFile ? "" : "border-danger"} position-relative`}>
                        <Input
                            id="profile-img-file-input"
                            type="file"
                            className="profile-img-file-input d-none"
                            onChange={(event) => {
                                const file = event.target.files[0]
                                if (file) {
                                    const previewUrl = URL.createObjectURL(file);
                                    setImageSrc(previewUrl);
                                    if ((file?.size / (1024 * 1024)) <= MAX_IMG_SIZE) {
                                        setInputFileName(file.name)
                                        if (!isValidFile) {
                                            setIsValidFile(true)
                                        }
                                        setSelectedFile(file)
                                    }
                                    else {
                                        setInputFileName("")
                                        setIsValidFile(false)
                                    }
                                }


                            }}
                            accept="image/*"
                        />
                        {imageSrc ? (
                            <div className='d-flex justify-content-between'>
                                <img
                                    src={imageSrc}
                                    alt="inputFileName"
                                    className='w-h-130'
                                />

                                <button
                                    onClick={() => {
                                        setImageSrc(null)
                                        setInputFileName("")
                                        setIsValidFile(true)
                                    }}
                                    className='img-remove-button'
                                >
                                    <span className='x-mark'>×</span>
                                </button>
                            </div>

                        ) : <Label
                            htmlFor="profile-img-file-input"
                            className="profile-photo-edit cursor-pointer"
                        >
                            <div className='icon-hover-zoom'>
                                <span className="text-primary">
                                    <i className="ri-upload-2-line icon-hover-zoom fs-2"></i>
                                </span>
                            </div>

                        </Label>}
                        <p className={`${isValidFile ? "fs-12 rv-label-muted" : "fs-12 rv-label-danger"}`}>
                            {inputFileName.length > 0 && isValidFile ? inputFileName : "JPEG, PNG, SVG format, upto 10 MB"}
                        </p>

                    </div> */}
                    <ImageUpload
                        validateSizeError={validateSizeError}
                        profilePicture={imageSrc}
                        isProfile={imageOn}
                        removeProfilePicture={() => {
                            setImageSrc(null)
                            setIsValidFile(true)
                            setImageSrc(false)
                            setValidateSizeError(null)
                        }}
                        isFromProfileScreen={true}
                        handleImageChange={(event) => {
                            const file = event.target.files[0];
                            const allowedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
                            if (!allowedFormats.includes(file.type)) {
                                setValidateSizeError(
                                    "Invalid file format. Please upload JPEG, PNG, or SVG."
                                );
                            }
                            if (file) {
                                const previewUrl = URL.createObjectURL(file);
                                setImageSrc(file);
                                if ((file?.size / (1024 * 1024)) <= MAX_IMG_SIZE) {
                                    if (!isValidFile) {
                                        setIsValidFile(true)
                                    }
                                    setSelectedFile(file)
                                    setImageOn(true)
                                }
                                else {
                                    setValidateSizeError("File size exceeds the limit (10MB)");
                                    setIsValidFile(false)
                                    setImageOn(false)
                                }
                            }
                        }}
                    ></ImageUpload>
                    <div class="d-flex justify-content-center gap-2 mt-3">
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                onClick={() => {
                                    if (roleName === 'systemUser') {
                                        navigate('/operator-listing');
                                    } else {
                                        navigate('/dashboard');
                                    }
                                }}
                            >
                                <i class="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                <span class="px-2 ms-2 me-1 fw-bold">
                                    Cancel
                                </span>
                            </button>

                            <button
                                disabled={!isValidFile || Object.keys(errors).length > 0}
                                class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                onClick={() => {
                                    if (roleName !== "Customer") {
                                        if (values?.username !== "" && values.firstname !== "" && values?.userrole?.value !== "") {
                                            handleChangeUser(values, dispatch, setLoading, navigate, userId, isProfile)
                                            handleImageUpload(selectedFile)
                                        }
                                    } else {
                                        handleSubmitCustomerFunction(values, dispatch, setLoading, customerId, setIsEdit, dialCode, navigate, selectedFile)
                                        handleImageUpload(selectedFile)
                                    }
                                }}
                            >
                                <i class="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                <span class="px-2 ms-2 me-1 fw-bold">
                                    Submit
                                </span>
                            </button>
                        </div>

                    </div>
                </div>
            </> : <>
                <div>
                    {formSchema.map((section, sectionIndex) => (
                        <React.Fragment key={sectionIndex}>
                            {section.title === "User" && section.sections &&
                                section.sections.map((subSection, subSectionIndex) => (
                                    subSection.sectionTitle === "Password Change" && (
                                        <div key={subSectionIndex}>
                                            <Row className='gy-4'>
                                                {subSection.fields.map((field, fieldIndex) => (
                                                    <Col xxl={12} md={12} lg={12} key={`${subSectionIndex}-${fieldIndex}`}>
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={
                                                                "ms-0 rv-form-label"
                                                            }
                                                            className={field.required ? "text-danger" : ""}
                                                            displayText={field.label}
                                                            important={field.required ? "*" : ""}
                                                        />
                                                        <LabelText
                                                            htmlFor={field.name}
                                                            classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] &&
                                                                errors[field.name]
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                                } `}
                                                            displayText={
                                                                touched[field.name] && errors[field.name]
                                                                    ? errors[field.name]
                                                                    : field.placeholder
                                                            }
                                                        />
                                                        <RenderField
                                                            field={field}
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            values={values}
                                                            touched={touched}
                                                            errors={errors}
                                                            setFieldTouched={setFieldTouched}
                                                            setFieldValue={setFieldValue}
                                                            options={userOptions}
                                                            removePlaceholder={true}
                                                        />
                                                        {/* <RenderErrorMessage
                                                            field={field}
                                                            touched={touched}
                                                            errors={errors}
                                                        /> */}
                                                    </Col>
                                                ))}

                                            </Row>
                                        </div>
                                    )
                                ))}
                        </React.Fragment>
                    ))}
                    <div class="d-flex justify-content-center gap-2 mt-3">
                        <div className="d-flex gap-2">
                            <button
                                type="button"
                                className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                onClick={() => {
                                    if (roleName === 'systemUser') {
                                        navigate('/operator-listing');
                                    } else {
                                        navigate('/dashboard');
                                    }
                                }}
                            >
                                <i class="ri-close-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                <span class="px-2 ms-2 me-1 fw-bold">
                                    Cancel
                                </span>
                            </button>

                            <button
                                class="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap btn btn-secondary"
                                onClick={() => {
                                    { if (values.newPassword !== "" && values.confirmNewPassword !== "") { handleChangePassword(values, dispatch, setLoading, navigate, userId) } }
                                }}
                            >
                                <i class="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>
                                <span class="px-2 ms-2 me-1 fw-bold">
                                    Submit
                                </span>
                            </button>
                        </div>

                    </div>
                </div>
            </>}

            {/* {activeTab === "2" && (
                <Col lg={12} className="d-flex justify-content-end mt-3">
                    <CommonButton outline={true} className={"cancel-button-background me-3"} color={"main-color"} type={"reset"} buttonAction={() => navigate(roleName === 'systemUser' ? '/operator-listing' : '/dashboard')} buttonText={"Cancel"} />
                    <Button color="main-color" onClick={() => { if (values.newPassword !== "" && values.confirmNewPassword !== "") { handleChangePassword(values, dispatch, setLoading, navigate, userId) } }}>
                        Confirm
                    </Button>
                </Col>
            )} */}
        </div>
    );
}
